export const PROXY_API_ROUTE = '/api/oc-api';
